export interface DirectLink {
  id: string;
  title: string;
  url: string;
  banner: string;
  order: number;
}

export default {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
  deserialize(input: any): DirectLink {
    return {
      id: input.sys.id || "",
      title: input.fields.title || "",
      url: input.fields.url || "",
      banner: input.fields.banner.fields.file.url || "",
      order: input.fields.order || 0,
    };
  },
};
